import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=48f4b723&scoped=true&"
var script = {}
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=48f4b723&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f4b723",
  null
  
)

export default component.exports